// extracted by mini-css-extract-plugin
export var bodyRow = "_cg-d";
export var cardColumns = "_cg-e";
export var ellipsesOverflow = "_cg-2";
export var flatBottomCorners = "_cg-3";
export var flatTopCorners = "_cg-4";
export var headerActionsDropdown = "_cg-f";
export var headerBottomRow = "_cg-c";
export var headerTopRow = "_cg-b";
export var orderDetailsWrapper = "_cg-0";
export var orderInfoContainer = "_cg-1";
export var productDetails = "_cg-9";
export var productImage = "_cg-5";
export var responsiveTable = "_cg-8";
export var shipmentContainer = "_cg-a";
export var tableBottomLeft = "_cg-6";
export var tableBottomRight = "_cg-7";
export var trackingLink = "_cg-g";